import React, { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";
import { Member, Organization } from "../common/ObjectTypes";
import { BackArrow } from "../common/ProjectIcons";
import DeleteButton from "../common/componentstyles/deleteButton";
import NoResults from "../common/NoResults";
import { containerClasses, tableClasses, textClasses, buttonClasses } from "../common/tailwindClassnames";

type OrganizationDetailsProps = {
    orgMembers: Member[],
    organization: Organization,
    onBackArrow: MouseEventHandler,
    onClickInvite: MouseEventHandler,
    onClickMember: Function,
    onToggleModal: MouseEventHandler,
    onToggleRemoveMemberModal: Function,
    currentMember: Member,
    superuser: boolean,
    pageLoaded: boolean
}

const OrganizationDetails = ({
    orgMembers,
    organization,
    onBackArrow,
    onToggleModal,
    onClickInvite,
    onClickMember,
    onToggleRemoveMemberModal,
    currentMember,
    superuser,
    pageLoaded
}: OrganizationDetailsProps) => {
    const { t } = useTranslation();
    return (
        <div className={containerClasses.page}>
            <div className="text-blue-basic dark:text-dark-blue-300 flex flex-row text-sm mb-3 cursor-pointer hover:underline w-min transition-colors duration-300"
                onClick={onBackArrow}>
                <BackArrow />  <label className="ml-2">{t("Workspaces")}</label>
            </div>
            <div className="mb-3 flex justify-between">
                <div>
                    <h1 className={textClasses.heading}>{organization.name}</h1>

                </div>
                {(currentMember.role === "admin" || superuser) && <div>
                    <button className="hover:bg-light-gray dark:hover:bg-neutral-gray-700 text-dark-green dark:text-dark-green-100 rounded px-5 py-2 mr-3 transition-colors duration-300"
                        onClick={onToggleModal}>
                        {t("Update")}
                    </button>
                    <button className={buttonClasses.primary}
                        onClick={onClickInvite}
                    >
                        {t("Add User")}
                    </button>
                </div>}
            </div>
            <table className={tableClasses.container}>
                <thead className={tableClasses.header}>
                    <tr>
                        <th className={tableClasses.headerCell}>
                            {t("Name")}
                        </th>
                        <th className={tableClasses.headerCell}>
                            {t("Email")}
                        </th>
                        <th className={tableClasses.headerCell}>
                            {t("Role")}
                        </th>
                        {(currentMember.role === "admin" || superuser) && <th className={tableClasses.headerCell}>
                            &nbsp;
                        </th>}
                    </tr>
                </thead>
                {!pageLoaded ?
                    <tbody className="text-sm">
                        {[...Array(8)].map((_, i) => (
                            <tr key={i} className="border border-gray-lines dark:border-secondary-gray bg-white dark:bg-off-black" data-testid="loading">
                                <td className={tableClasses.cell}><div className="h-4 w-32 bg-neutral-gray-50 dark:bg-neutral-gray-700 rounded animate-pulse" /></td>
                                <td className={tableClasses.cell}><div className="h-4 w-48 bg-neutral-gray-50 dark:bg-neutral-gray-700 rounded animate-pulse" /></td>
                                <td className={tableClasses.cell}><div className="h-4 w-16 bg-neutral-gray-50 dark:bg-neutral-gray-700 rounded animate-pulse" /></td>
                                {(currentMember.role === "admin" || superuser) && (
                                    <td className={tableClasses.cell}><div className="h-4 w-6 bg-neutral-gray-50 dark:bg-neutral-gray-700 rounded animate-pulse" /></td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                    :
                    <tbody className="text-sm dark:text-white transition-colors duration-300">
                        {orgMembers.map((org_member: Member) => {
                            return (
                                <tr key={org_member.id ? org_member.id.toString() : Math.random()}
                                    className="border border-gray-lines dark:border-secondary-gray hover:bg-light-blue dark:hover:bg-neutral-gray-700 bg-white dark:bg-off-black transition-colors duration-300">
                                    <td className={tableClasses.cell}
                                        onClick={() => onClickMember(org_member.id)}>
                                        {org_member.full_name}
                                    </td>
                                    <td className={tableClasses.cell}
                                        onClick={() => onClickMember(org_member.id)}>
                                        {org_member.email}
                                    </td>
                                    {/* <td className="p-3">
                                            Non mvp
                                        </td> */}
                                    <td className={tableClasses.cell}
                                        onClick={() => onClickMember(org_member.id)}>
                                        {org_member.role}
                                    </td>
                                    {(currentMember.role === "admin" || superuser) && (
                                        <td className={tableClasses.cell + " text-right"}>
                                            <DeleteButton
                                                onClick={() => onToggleRemoveMemberModal(org_member.id)}
                                            />
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>}
                {pageLoaded && orgMembers.length === 0 &&
                    <tbody><tr><td colSpan={(currentMember.role === "admin" || superuser) ? 4 : 3} className="py-16">
                        <NoResults
                            headerMsg={t("No Members Found")}
                            labelMsg={t("You may need to add your first member, or contact system admin.")}
                        />
                    </td></tr></tbody>}
            </table>
        </div>
    );
};

export default OrganizationDetails;